import { Box, Theme } from '@mui/material';
import { createUseStyles } from 'react-jss';
import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { getBreakpoint } from '@/theme';

interface Props {
  children: ReactNode;
  className?: string;
}

const useStyles = createUseStyles((theme: Theme) => ({
  tabContent: {
    padding: '0px 16px 0px 18px',
    color: theme.palette.text.primary,
  },
  [getBreakpoint('md')]: {
    tabContent: {
      padding: '0px 8px 0px 8px',
    },
  },
}));

const TabContent: FC<Props> = ({ children, className = '' }) => {
  const styles = useStyles();
  const compClass = classNames(styles.tabContent, className);
  return <Box className={compClass}>{children}</Box>;
};

export default TabContent;
